import { BaseStore } from "stores/base_store"
import { runInAction, makeAutoObservable } from "mobx"
import { api_get } from "api/utils"
import { api_post } from "api/utils"
import { CursorType } from "utils/types"
export type RequestDelayType = {
    key: string;
    uuid: string;

    request: string;
    identity: string;
    status: string;

    // delayed until this time
    scheduled_time: string;

    // how long after the delay do we expire and give to someone else
    expire_seconds: number;

    // Was reminder sent?
    fired_date: string;

    // Did the assistant clock expire before it expired?
    resolved_date: string;

    // Did the timer expire before they clocked in?
    expired_date: string;

    // was it cancelled?
    canceled_date: string;
    canceled_identity: string;

    date_created: string;
    date_updated: string;

    updateProps?: (attributes: RequestDelayType) => void;
};

// Domain object RequestDelay
export class RequestDelay implements RequestDelayType {
    key = "";
    uuid = "";
    identity = "";
    request = "";
    status = "";
    scheduled_time = "";
    expire_seconds = 0;
    fired_date = "";
    resolved_date = "";
    expired_date = "";
    canceled_date = "";
    canceled_identity = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: RequestDelayType) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: RequestDelayType) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class RequestDelayStore extends BaseStore<RequestDelayType, RequestDelay> {

    async fetchListByRequest(identity: string, request: string, cursor: CursorType = null) {
        const params = { identity: identity, request, cursor: cursor || '' };
        const response = await api_get("/request-delay/list/by-request", params);
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data.items);
            if(data.cursor) {
                this.fetchListByRequest(identity, request, data.cursor);
            }
            return data;
        }
        return null;
    }

    async doCancel(workKey: string, delay: string) {
        const response = await api_post("/request-delay/cancel", { identity: workKey, delay });
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }

    modelConstructor() {
        return RequestDelay;
    }

}
